module.exports = __webpack_public_path__ + "img/ic_badge_excellent.18aa7152.png";